import * as React from "react";
import { connect } from "common/connect";
import StoreKeys from "common/storeKeys";
import {
    BountyModel,
    bountyModelContext,
    fillBountyFreeformParts,
} from "common/helpers/bountyHelper";
import BountyBracket from "./BountyBracket";
import BountyBracketEditor from "./BountyBracketEditor";
import { useBracketSurface } from "./BracketSurface";

const propKeys = {
    eventData: StoreKeys.EVENT.EVENTDATA,
    format: StoreKeys.EVENT.FORMAT,
    userBracketPicks: StoreKeys.EVENT.USER.BRACKET_PICKS,
    officialBracketPicks: StoreKeys.EVENT.OFFICIAL.BRACKET_PICKS,
    isEditing: StoreKeys.EVENT.IS_EDITING,
    stageIndex: StoreKeys.EVENT.STAGE_INDEX,
    showOfficial: StoreKeys.EVENT.SHOW_OFFICIAL,
};

function BountyBracketRendererC({
    eventData,
    format,
    userBracketPicks,
    officialBracketPicks,
    isEditing,
    stageIndex,
    showOfficial,
}) {
    const { ready, svgWrapper, surfaceProps } = useBracketSurface();

    const currentStage = format.stages[stageIndex];
    const currentEventStage = eventData.eventStages[stageIndex];

    const model = new BountyModel(
        bountyModelContext(
            eventData,
            currentStage,
            currentEventStage,
            officialBracketPicks,
            userBracketPicks
        )
    );

    const parts = fillBountyFreeformParts(model, eventData.teams, {
        official: showOfficial,
        withCues: !showOfficial,
    });

    return (
        <>
            {isEditing && <BountyBracketEditor />}
            {!isEditing && (
                <div {...surfaceProps}>
                    {ready && (
                        <BountyBracket
                            parts={parts}
                            svgWrapper={svgWrapper}
                            hideSeriesScore={!model.useSeriesScore}
                        />
                    )}
                </div>
            )}
        </>
    );
}

export default function BountyBracketRenderer(props) {
    return connect(<BountyBracketRendererC />, propKeys, props);
}
